import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProgressSpinnerComponent } from './progress-spinner.component';
import { EllipsisLoadingComponent } from 'src/app/shared/components/ellipsis-loading/ellipsis-loading.component';
export { ProgressSpinnerComponent } from './progress-spinner.component';
@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    EllipsisLoadingComponent
  ],
  declarations: [ProgressSpinnerComponent],
  exports: [ProgressSpinnerComponent]
})
export class ProgressSpinnerModule { }
